import type { Template } from "@/types";

export const PO_06_H0_V6: Template[] = [
    {
        id: "po-06-h0v6-01",
        name: "PO 01 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 107, y: 181, width: 290, height: 465, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 404, y: 181, width: 138, height: 229, rotation: 0, imageRotation: 0 },
            { id: "3", x: 404, y: 418, width: 138, height: 228, rotation: 0, imageRotation: 0 },
            { id: "4", x: 693, y: 127, width: 367, height: 575, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1068, y: 127, width: 187, height: 284, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1068, y: 419, width: 187, height: 283, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-02",
        name: "PO 02 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 67, y: 166, width: 163, height: 244, rotation: 0, imageRotation: 0 },
            { id: "2", x: 67, y: 418, width: 163, height: 243, rotation: 0, imageRotation: 0 },
            { id: "3", x: 238, y: 166, width: 345, height: 495, rotation: 0, imageRotation: 0 },
            { id: "4", x: 716, y: 166, width: 345, height: 495, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1069, y: 166, width: 163, height: 244, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1069, y: 418, width: 163, height: 243, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-03",
        name: "PO 03 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 50, y: 127, width: 367, height: 575, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 425, y: 127, width: 174, height: 284, rotation: 0, imageRotation: 0 },
            { id: "3", x: 425, y: 419, width: 174, height: 283, rotation: 0, imageRotation: 0 },
            { id: "4", x: 750, y: 184, width: 289, height: 460, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1047, y: 184, width: 152, height: 226, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1047, y: 418, width: 152, height: 226, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-04",
        name: "PO 04 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_04.png",
        size: [1298, 827],
        style: {},
        slots: [         
            { id: "1", x: 55, y: 217, width: 266, height: 394, rotation: 0, imageRotation: 0 },
            { id: "2", x: 329, y: 217, width: 266, height: 394, rotation: 0, imageRotation: 0 },
            { id: "3", x: 703, y: 127, width: 399, height: 575, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1110, y: 127, width: 134, height: 187, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1110, y: 322, width: 134, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1110, y: 516, width: 134, height: 186, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-05",
        name: "PO 05 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_05.png",
        size: [1298, 827],
        style: {},
        slots: [      
            { id: "1", x: 52, y: 217, width: 133, height: 193, rotation: 0, imageRotation: 0 },
            { id: "2", x: 52, y: 418, width: 133, height: 193, rotation: 0, imageRotation: 0 },
            { id: "3", x: 193, y: 217, width: 263, height: 394, rotation: 0, imageRotation: 0 },
            { id: "4", x: 464, y: 217, width: 133, height: 193, rotation: 0, imageRotation: 0 },
            { id: "5", x: 464, y: 418, width: 133, height: 193, rotation: 0, imageRotation: 0 },
            { id: "6", x: 649, y: 0, width: 649, height: 827, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-06",
        name: "PO 06 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_06.png",
        size: [1298, 827],
        style: {},
        slots: [         
            { id: "1", x: 54, y: 127, width: 134, height: 187, rotation: 0, imageRotation: 0 },
            { id: "2", x: 54, y: 322, width: 134, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 54, y: 516, width: 134, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 196, y: 127, width: 399, height: 575, rotation: 0, imageRotation: 0 },
            { id: "5", x: 703, y: 217, width: 268, height: 394, rotation: 0, imageRotation: 0 },
            { id: "6", x: 979, y: 217, width: 267, height: 394, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-07",
        name: "PO 07 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 649, height: 827, rotation: 0, imageRotation: 0 },
            { id: "2", x: 697, y: 217, width: 273, height: 394, rotation: 0, imageRotation: 0 },
            { id: "3", x: 978, y: 217, width: 132, height: 193, rotation: 0, imageRotation: 0 },
            { id: "4", x: 978, y: 418, width: 132, height: 193, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1118, y: 217, width: 132, height: 193, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1118, y: 418, width: 132, height: 193, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-08",
        name: "PO 08 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 132, width: 446, height: 563, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 454, y: 132, width: 191, height: 278, rotation: 0, imageRotation: 0 },
            { id: "3", x: 454, y: 418, width: 191, height: 277, rotation: 0, imageRotation: 0 },
            { id: "4", x: 653, y: 132, width: 191, height: 278, rotation: 0, imageRotation: 0 },
            { id: "5", x: 653, y: 418, width: 191, height: 277, rotation: 0, imageRotation: 0 },
            { id: "6", x: 852, y: 132, width: 446, height: 563, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-09",
        name: "PO 09 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 260, width: 210, height: 307, rotation: 0, imageRotation: 0 },
            { id: "2", x: 218, y: 260, width: 210, height: 307, rotation: 0, imageRotation: 0 },
            { id: "3", x: 436, y: 260, width: 210, height: 307, rotation: 0, imageRotation: 0 },
            { id: "4", x: 654, y: 260, width: 210, height: 307, rotation: 0, imageRotation: 0 },
            { id: "5", x: 872, y: 260, width: 209, height: 307, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1089, y: 260, width: 209, height: 307, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-10",
        name: "PO 10 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 45, y: 271, width: 195, height: 285, rotation: 0, imageRotation: 0 },
            { id: "2", x: 248, y: 271, width: 195, height: 285, rotation: 0, imageRotation: 0 },
            { id: "3", x: 451, y: 271, width: 195, height: 285, rotation: 0, imageRotation: 0 },
            { id: "4", x: 654, y: 271, width: 195, height: 285, rotation: 0, imageRotation: 0 },
            { id: "5", x: 857, y: 271, width: 194, height: 285, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1059, y: 271, width: 194, height: 285, rotation: 0, imageRotation: 0 }
        ],
    }
];